import React, {useEffect, useState} from 'react';
import {Button, Input} from "antd";
import axios from "axios";
import {API_BASE_URL} from "../constants";

const UrlInputSource = ({onExifInfo}) => {

    const [value, setValue] = useState();
    useEffect(() => {
        if (window.location.search) {
            const srcUrl = new URLSearchParams(window.location.search).get("srcUrl");
            if (srcUrl) {
                axios.post(`${API_BASE_URL}/exif`, {imgUrl: srcUrl})
                    .then(async resp => {
                        onExifInfo({...resp.data, srcUrl});
                        setValue(undefined)
                    });
            }
        }
    }, []);

    const onClick = () => {
        axios.post(`${API_BASE_URL}/exif`, {imgUrl: value})
            .then(async resp => {
                onExifInfo({...resp.data, srcUrl: value});
                setValue(undefined)
            });
    }

    return (<Input.Group compact>
        <Input value={value}
               onChange={e => setValue(e.target.value)}
               style={{width: 'calc(100% - 78px)'}}
               placeholder={'Paste image URL here'}/>
        <Button type="primary" onClick={onClick}>Submit</Button>
    </Input.Group>);
}

export default UrlInputSource;


// WEBPACK FOOTER //
// ./src/uploader/UrlInputSource.js